import React from 'react';

import { useMutation } from '@apollo/client';
import TicketForm from '../TicketForm';
import { GET_CUSTOMER, GET_ACTION_ITEMS, GET_CUSTOMER_TICKETS } from '../../Customers/graphql/queries';
import useNotification from '../../../Notifications/useNotifications';

import { TicketFormType } from '../TicketForm/TicketForm';
import moment from 'moment';
import { CREATE_TICKET } from '../graphql/mutations';
import { useNavigate, useParams } from 'react-router-dom';

const NewTicket = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { addSuccess, addError } = useNotification();

  const [createTicket] = useMutation(CREATE_TICKET, {
    refetchQueries: [
      { query: GET_CUSTOMER, variables: { id } },
      { query: GET_ACTION_ITEMS },
      { query: GET_CUSTOMER_TICKETS, variables: { customerId: id } }
    ],
    awaitRefetchQueries: true,
    onCompleted: ({ createTicket }) => {
      if (createTicket) {
        addSuccess('New ticket created successfully');
        navigate(`/customers/details/${id}`);
      } else {
        addError('Error creating booking. Please try again.');
      }
    }
  });

  const onSubmit = async (values: TicketFormType) => {
    const departureDate = moment(values.date).toISOString();

    console.log(values, id);
    await createTicket({ variables: { values: { ...values, date: departureDate, customerId: id } } });
  };

  return (
    <>
      <>
        <h1 className="my-6 text-3xl">New Ticket</h1>
        <TicketForm onSubmit={onSubmit} />
      </>
    </>
  );
};

export default NewTicket;
